import React, { useState } from 'react';
import {
  Dialog,
  Box,
  CircularProgress,
  Button,
  useTheme,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';
import PerfectScrollbars from 'react-perfect-scrollbar';
import JVDetails from './JVDetails';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import HorizontalDetails from 'src/views/trans/TransView/HorizontalDetails';
import TransViewTable from './TransViewTable';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
/**
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {VoidFunction} props.onClose
 * @param {boolean} props.isLoading
 * @param {object} props.transDetails
 * @returns
 */
const TransView = ({
  open = false,
  onClose = () => {},
  isLoading = false,
  transDetails = {},
  settings = {}
}) => {
  const theme = useTheme();
  const [isFullscreen, setIsFullscreen] = useState(false);

  const { base_url, userToken, biz = {}, current_user } = useSelector(
    state => state.auth
  );
  const fullscreen = () => {
    setIsFullscreen(prev => !prev);
  };

  return (
    <Dialog
      fullScreen={isFullscreen}
      maxWidth={isFullscreen ? false : 'md'}
      fullWidth
      open={open}
      onClose={onClose}
    >
      <Box id="trans-view" p={2}>
        <Box>
          <PerfectScrollbars>
            {isLoading ? (
              <Box
                height={400}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress size={40} />
              </Box>
            ) : (
              <>
                {!isEmpty(transDetails) && (
                  <>
                    <Box padding={0.5}>
                      <Box
                        display="flex"
                        justifyContent="flex-end"
                        marginTop={-1}
                      >
                        <Tooltip
                          title={
                            isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'
                          }
                        >
                          <IconButton
                            size="medium"
                            color="primary"
                            onClick={fullscreen}
                          >
                            <FullscreenIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>

                      <Box marginBottom={2}>
                        <Typography
                          variant="h4"
                          component="p"
                          color="textSecondary"
                          style={{ marginBottom: 2 }}
                        >
                          {settings?.quickView?.allowView?.jvDetails?.label}
                        </Typography>
                        <JVDetails
                          jv={transDetails}
                          wf={transDetails?._rm?.jsonWF?.wf}
                          biz={biz}
                          wfStatus={transDetails?.wfStatus}
                        />
                      </Box>

                      {settings?.quickView?.trans_inv && (
                        <Box
                          mt={2}
                          marginBottom={2}
                          sx={
                            !settings?.allowEdit
                              ? { pointerEvents: 'none' }
                              : {}
                          }
                        >
                          <Typography
                            variant="h4"
                            component="p"
                            color="textSecondary"
                            style={{ marginBottom: 2 }}
                          >
                            {settings?.quickView?.labelDetails}
                          </Typography>
                          <HorizontalDetails
                            jid={transDetails}
                            uuid={transDetails.uuid}
                            ixTL={transDetails.ixTL}
                            base_url={base_url}
                            userToken={userToken}
                            itemValue={transDetails.kvs}
                            inputSettings={transDetails._rm?.kvs}
                            handleUpdateOtherDetailsCallBack={() => {}}
                          />
                        </Box>
                      )}

                      {settings?.quickView &&
                        Object.entries(settings.quickView)
                          .filter(
                            ([key, value]) =>
                              typeof value === 'object' && value?.tableColumns
                          )
                          .map(([key, value]) => (
                            <Box marginBottom={2} key={key}>
                              <Typography
                                variant="h4"
                                component="p"
                                color="textSecondary"
                                style={{ marginBottom: 8 }}
                              >
                                {value.labelTable}
                              </Typography>
                              <TransViewTable
                                transDetails={transDetails}
                                settings={value.tableColumns}
                                source={key}
                              />
                            </Box>
                          ))}
                    </Box>
                  </>
                )}
              </>
            )}
          </PerfectScrollbars>
        </Box>
        <Box
          width="100%"
          display="flex"
          justifyContent="flex-end"
          style={{ columnGap: theme.spacing(1) }}
        >
          <Button color="primary" onClick={onClose}>
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            href={'/app/trans/' + transDetails.jid}
            target="_blank"
            endIcon={<OpenInNew />}
          >
            View
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default React.memo(TransView);
